import { Button, Image } from "antd";
import React, { useEffect, useState } from "react";
import { EyeOutlined } from "@ant-design/icons";

const ImageGallery = ({ data }) => {
  const [selected, setSelected] = useState(null);
  const [remaining, setRemaining] = useState(null);

  useEffect(() => {
    if (data) {
      setRemaining(data);
      setSelected(data[0]);
    }
  }, [data]);

  const handleSelectImage = (image) => {
    setSelected(image);
  };

  return (
    <>
      <Image.PreviewGroup
        preview={{
          onChange: (current, prev) =>
            console.log(`current index: ${current}, prev index: ${prev}`),
        }}
      >
        {remaining !== null &&
          remaining.map((i, k) => (
            <Image
              key={k}
              src={i}
              style={{ display: i === selected ? "block" : "none" }}
              preview={{
                mask: (
                  <div>
                    <EyeOutlined /> Ampliar
                  </div>
                ),
              }}
            />
          ))}
      </Image.PreviewGroup>
      <div className="mt-2 space-x-2 space-y-2">
        {remaining !== null &&
          remaining.map((i, k) => (
            <Image
              key={k}
              src={i}
              style={{ border: i === selected ? "1px solid black" : "none" }}
              className="h-10"
              width="40px"
              onClick={() => handleSelectImage(i)}
              preview={false}
            />
          ))}
      </div>
    </>
  );
};

export default ImageGallery;
